// External libraries
import { css } from '@emotion/core';

const textStyles = css`
  font-size: 0.8rem;
  line-height: 1.6;
  text-align: left;

  strong {
    font-weight: bold;
  }
`;

export { textStyles };
